import { render, staticRenderFns } from "./PreservationRecordList.vue?vue&type=template&id=8141d15e&"
import script from "./PreservationRecordList.vue?vue&type=script&lang=ts&"
export * from "./PreservationRecordList.vue?vue&type=script&lang=ts&"
import style0 from "./PreservationRecordList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports